import { IconButton, Menu, Tooltip } from "@mui/material";
import EmojiPicker from "emoji-picker-react"; 
import PropTypes from "prop-types";
import { useState } from "react";
import Iconify from "../iconify/Iconify";

PopoutAddEmoji.propTypes = {
  toolbarButtonStyle: PropTypes.object,
  quillRef: PropTypes.object
}

export function PopoutAddEmoji({ toolbarButtonStyle, quillRef }) {
  const [quillSelectedPosition, setQuillSelectedPosition] = useState(-1);
  const [activeElement, setActiveElement] = useState(null);

  const onPickerClick = (e) => {
    const selectedRange = quillRef?.current?.editor?.getSelection() ?? {};
    setQuillSelectedPosition(selectedRange?.index ?? -1);
    setActiveElement(window.getSelection()?.anchorNode?.parentNode ?? e.target);  
  }

  const onClose = () => {
    setQuillSelectedPosition(-1);
    setActiveElement(null);
  }

  const insertEmoji = (emoji) => { 
    quillRef?.current?.editor?.insertEmbed(quillSelectedPosition, 'emoji', { src: emoji.imageUrl, alt: emoji.emoji });
    quillRef?.current?.editor?.setSelection(quillSelectedPosition + 1, 0);
    onClose();
  };

  return <>
    <Tooltip title="Emoji">
      <IconButton sx={{ p: 0, m: 0, ":focus": { color: "rgb(33, 43, 54) !important" } }} disableFocusRipple disableRipple onClick={onPickerClick}>
        <Iconify icon={"iconoir:emoji"} style={{ width: toolbarButtonStyle.width, height: toolbarButtonStyle.height }} />
      </IconButton>
    </Tooltip>

    <Menu anchorEl={activeElement} open={quillSelectedPosition !== -1 && !!activeElement} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} onClose={onClose}>
      <EmojiPicker previewConfig={{ showPreview: false }} open onEmojiClick={(val) => insertEmoji(val)} />
    </Menu>
  </>;
};